import React, { useState, useEffect, useRef } from "react";
import Input from "../element/Input/Input";

function StatusMultiSelectDropdown({
  title,
  updateFilter,
  statusData,
  enableNeverUploaded,
  fieldName,
  multiSelect,
  // setFilterStatus,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [filterStatus, setFilterStatus] = useState(multiSelect ? [] : undefined);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);

  const normalizeOption = (item) => {
    if (item && typeof item === "object") {
      return {
        label: item?.label ?? "",
        value: item?.value ?? "",
      };
    }
    return { label: item ?? "", value: item ?? "" };
  };

  const formatLabel = (value) => {
    if (!value) return "";
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (value) => {
    setCheckData(true);

    if (multiSelect) {
      setFilterStatus((prev) => {
        const previous = Array.isArray(prev) ? prev : [];
        if (value === "never_uploaded") {
          return ["never_uploaded"];
        }

        const filteredPrevious = previous.filter((v) => v !== "never_uploaded");
        if (filteredPrevious.includes(value)) {
          return filteredPrevious.filter((v) => v !== value);
        }
        return [...filteredPrevious, value];
      });
      return;
    }

    setFilterStatus(value);
  };

  const clearSelection = () => {
    setFilterStatus(multiSelect ? [] : undefined);
    setCheckData(true);
  };

  useEffect(() => {
    if (checkData) {
      const selectedValues = multiSelect
        ? (Array.isArray(filterStatus) ? filterStatus : [])
        : (filterStatus ? [filterStatus] : []);

      if (selectedValues.length === 0) {
        if (enableNeverUploaded) {
          updateFilter("never_uploaded", false);
        }
        updateFilter(fieldName || "status", "");
        return;
      }

      if (enableNeverUploaded && selectedValues.includes("never_uploaded")) {
        updateFilter("never_uploaded", true);
        updateFilter(fieldName || "status", "");
        return;
      }

      if (enableNeverUploaded) {
        updateFilter("never_uploaded", false);
      }

      const normalized = selectedValues
        .filter((v) => typeof v === "string" && v.trim())
        .map((v) => v.charAt(0).toUpperCase() + v.slice(1));

      const updateStatus = multiSelect ? normalized.join(",") : (normalized[0] || "");
      updateFilter(fieldName || "status", updateStatus);
    }
  }, [filterStatus]);

  return (
    <div className="relative inline-block text-left w-auto" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        type="button"
        className="flex items-center justify-between w-full min-w-[8rem] px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 whitespace-nowrap"
      >
        <span className="whitespace-nowrap">{title}</span>
        {multiSelect ? (
          Array.isArray(filterStatus) && filterStatus.length > 0 && (
            <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
              {filterStatus.length}
            </span>
          )
        ) : (
          filterStatus && (
            <span className="inline-flex ml-1 items-center justify-center w-2 h-2 bg-blue-600 rounded-full">
            </span>
          )
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X client_org_ids' and Clear button */}
          <div className="flex items-center justify-end p-2 border-b border-gray-200">
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>
          <div className="items-center max-h-48 overflow-y-auto">
            {statusData?.map((item, index) => {
              const normalized = normalizeOption(item);
              return (
                <div
                  className="flex items-center px-3 py-2 hover:bg-gray-50"
                  key={index}
                >
                  <label className="flex items-center space-x-2">
                    <Input
                      type={multiSelect ? "checkbox" : "radio"}
                      name="status"
                      checked={
                        multiSelect
                          ? Array.isArray(filterStatus) && filterStatus.includes(normalized.value)
                          : filterStatus === normalized.value
                      }
                      inputchangehandler={() => handleSelect(normalized.value)}
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                    />
                    <span className="text-gray-700">
                      {/* {item.charAt(0).toUpperCase() +
                        item.slice(1).toLowerCase()} */}
                      {formatLabel(normalized.label)}
                    </span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default StatusMultiSelectDropdown;
